import { render, staticRenderFns } from "./ModuleMenu.vue?vue&type=template&id=c4ff3664&scoped=true&"
import script from "./ModuleMenu.vue?vue&type=script&lang=js&"
export * from "./ModuleMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMenu.vue?vue&type=style&index=0&id=c4ff3664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff3664",
  null
  
)

export default component.exports